import React from "react";
import { useField } from "formik";
import styled from "styled-components";
import { InputPropsWithoutRef } from "react-html-props";

const RadioField = (props: Props) => {
  const { label, id, children, ...otherProps } = props;
  const [field] = useField({ ...props, type: "radio" });

  return (
    <FieldWrapper>
      <RadioLabel htmlFor={id}>
        <RadioInput id={id} {...otherProps} {...field} type="radio" />
        {children || label}
      </RadioLabel>
    </FieldWrapper>
  );
};

interface Props extends InputPropsWithoutRef {
  label?: string;
  children?: React.ReactNode;
  name: string;
}

const FieldWrapper = styled.div`
  font-family: ${({ theme }) => theme.font};
  color: ${({ theme }) => theme.colors.text};
`;

const RadioLabel = styled.label`
  display: flex;
  align-items: center;
  margin-bottom: 0;
`;

const RadioInput = styled.input`
  // This is a hack to make this styling more specific and override some global
  // input styling from bootstrap.
  &&& {
    margin: 0;
    margin-right: 0.5rem;
    display: inline-block;
  }

  :focus {
    outline-color: ${({ theme }) => theme.colors.primary};
  }
`;

export default RadioField;
